<template>
  <div>

    <video id="beepChatId" src="/notific.mp3" style="display: none;" ></video>
    <video id="beepPagId" src="/message-pag.ogg" style="display: none;" ></video>
    
    <!-- Modal -->
    <div class="modal fade" id="modalChat" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" style="z-index:100000000">
        <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span v-if="!to">Chat</span>
                        <template v-else-if="to.id_chat_sala">
                            <a href="#" @click.prevent="to = null" class="mr-3"><i class="fas fa-chevron-left"></i></a> 
                            <span>
                                <i class="fa-solid fa-users mr-2"></i>
                                {{ to.st_titulo }}
                            </span>
                        </template>
                        <template v-else>
                            <a href="#" @click.prevent="to = null" class="mr-3"><i class="fas fa-chevron-left"></i></a> 

                            <i class="fa fa-check-circle text-success mr-3" aria-hidden="true" v-if="is_online(to)"></i>
                            <i class="fa fa-minus-circle text-danger mr-3" aria-hidden="true" v-else></i>

                            <span>{{ to.name }}</span>
                        </template>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <template v-if="!to">
                        <az-input 
                            class="mb-3"
                            type="button-group"
                            :optionsList="opcoes_selecao" 
                            v-model="viewMode"
                            @input="trocar_opcao()" />

                        <template v-if="viewMode == 'OFF'">

                            <az-input
                                placeholder="Informe o usuário..."
                                icon="fas fa-user"
                                type="autocomplete" 
                                optionsMode="aql"
                                service="usuarios.index"
                                :optionsParm="{ chat: true }"
                                v-model="usuarioSelecionado"
                                ref="info_usuario"
                                @input="selecionarUsuario()" />

                            <br><br><br><br><br><br><br><br><br><br>

                        </template>

                        <!-- MENSAGENS NÃO LIDAS -->
                        <template v-else-if="viewMode == 'MNL'">
                            <div class="list-group" v-if="Object.keys(nao_lidas).length">
                                <button type="button" class="list-group-item list-group-item-action" 
                                    v-for="(msgs, usuario, iux) in nao_lidas" :key="iux"
                                    @click="( msgs[0].sala && msgs[0].sala.st_tipo == 'P2G' ) ? abrirSala(msgs[0].sala) : abrirSala(msgs[0].usuario)">
                                    <span class="badge badge-secondary">{{ msgs.length }}</span>
                                    {{ usuario }}
                                </button>
                            </div>

                            <az-empty-state v-else msg="Nenhuma mensagem não lida." icon="fas fa-comment-dots" />

                        </template>

                        <template v-else-if="viewMode == 'REC'">
                            <div class="alert alert-info">
                                As 10 interações mais recentes realizadas nos últimos 5 dias.
                            </div>

                            <ul class="list-group" v-if="recentes && recentes.length">
                                <li class="list-group-item" v-for="(recente, iux) in recentes" :key="iux">
                                    <a href="#" @click.prevent="abrirSala(recente.sala)" v-if="recente.sala && recente.sala.st_tipo == 'P2G'" class="card-link">
                                        <i class="fa-solid fa-users fa-fw mr-2"></i>
                                        {{ recente.sala.st_titulo }}
                                    </a>
                                    <span class="text-muted" v-else-if="recente.id_usuario == $store.state.user.id_usuario">
                                        {{ recente.usuario.search }}    
                                    </span>
                                    <a href="#" v-else @click="abrirSala(recente.usuario)">
                                        {{ recente.usuario.search }}
                                    </a>
                                    
                                    <div class="text-muted small">
                                        {{ $util.getFormatDate(recente.dt_mensagem) }}
                                        {{ recente.dt_mensagem.substr(11, 5) }}
                                    </div>
                                </li>
                            </ul>

                            <az-empty-state 
                                v-else
                                msg="Nenhuma interação recentes nos últimos 5 dias"
                                icon="fa-solid fa-comments" />
                        </template>

                        <!-- Grupos -->
                        <template v-else-if="viewMode == 'GRP'">

                            <div class="alert alert-info" v-if="false">
                                As 10 interações mais recentes realizadas nos últimos 5 dias.
                            </div>

                            <ul class="list-group" v-if="grupos && grupos.length">
                                <li class="list-group-item d-flex justify-content-between" v-for="(grupo, iux) in grupos" :key="iux">
                                    <div>
                                        <a href="#" @click="abrirSala(grupo)" class="card-link">
                                            {{ grupo.st_titulo }}    
                                        </a>
                                        <span class="badge badge-secondary ml-2" v-if="grupo.membros && grupo.membros.length" title="Membros">{{ grupo.membros.length }}</span>
                                        
                                    </div>
                                    <div>
                                        <div class="text-muted small" v-if="grupo.dt_mensagem">
                                            {{ $util.getFormatDate(grupo.dt_mensagem) }}
                                            {{ grupo.dt_mensagem.substr(11, 5) }}

                                            <span class="ml-3 badge badge-secondary">
                                                #{{ grupo.id_chat_sala }}
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <az-empty-state 
                                v-else
                                msg="Nenhum grupo disponível"
                                icon="fa-solid fa-users-line"
                                :action="'Incluir Grupo'" 
                                :method="incluir_grupo" />

                        </template>

                        <!-- Contatos -->

                        <template v-else>

                            <div class="mb-2">
                                <az-input
                                    placeholder="Pesquisar..."
                                    icon="fa fa-search" 
                                    sizing="sm"
                                    ref="search_chat"
                                    v-model="search">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">{{ lista_conectados ? lista_conectados.length : 0 }}</span>
                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Aviso Sonoro" @click="toggle_aviso_sonoro()">
                                                <i class="fa-solid fa-volume-xmark fa-fw" v-if="!aviso_sonoro"></i>        
                                                <i class="fa-solid fa-volume-high fa-fw" v-else></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>

                            <ul class="list-group" v-if="lista && lista.length">
                                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(user, iux) in lista" :key="iux">
                                    <span class="text-muted" v-if="user.id_usuario == $store.state.user.id_usuario">
                                        {{ user.search ? user.search : user.name }}    
                                    </span>
                                    <a href="#" v-else @click="abrirSala(user)" class="card-link">
                                        {{ user.search ? user.search : user.name }}
                                    </a>
                                    <div>
                                        <span v-if="user.js_classes && user.js_classes.length">
                                            <a href="#" @click.prevent="selecionar_classe(classe)"
                                                v-for="(classe, icx) in user.js_classes" :key="icx">
                                                <span class="badge badge-success ml-1">
                                                    {{ classe }}
                                                </span>
                                            </a>
                                        </span>

                                        <span v-else-if="user.classes && user.classes.length">
                                            <a href="#" @click.prevent="selecionar_classe(classe)"
                                                v-for="(classe, icx) in user.classes" :key="icx">
                                                <span class="badge badge-success ml-1">
                                                    {{ classe }}
                                                </span>
                                            </a>
                                        </span>

                                        <a href="#" @click.prevent="desconectar(user)" v-if="$store.state.user.desconectar" class="card-link ml-3">
                                            <i class="fa fa-times" :class="user.desconexao ? 'text-muted' : 'text-danger'" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </li>
                            </ul>

                            <az-empty-state v-else msg="Nenhuma usuário identificado." icon="fas fa-users-slash" />

                        </template>

                    </template>

                    <!-- Exibição das Mensagens -->
                    <template v-else>
                        <az-empty-state v-if="!mensagens || !mensagens.length" msg="Nenhuma mensagem trocada." icon="fas fa-comments" />
                        <template v-else>
                            <ul class="list-group">
                                <li class="list-group-item" 
                                    :class="msg.id_usuario == $store.state.user.id_usuario ? 'list-group-item-success' : 'list-group-item-secondary'" 
                                    v-for="(msg, imx) in mensagens" :key="imx">
                                    <div class="small text-muted" :class="msg.id_usuario == $store.state.user.id_usuario ? 'text-right' : ''">
                                        {{ $util.getFormatDate(msg.dt_mensagem) }}
                                        {{ msg.dt_mensagem.substr(11,8) }}
                                        <span class="badge badge-warning" v-if=" msg.id_usuario != $store.state.user.id_usuario && !msg.fl_recebida">Nova</span>

                                        <a href="#" @click.prevent="abrirSala({ id_usuario: msg.id_usuario })" v-if=" ( msg.id_usuario != $store.state.user.id_usuario ) && msg.usuario">
                                            <span class="badge badge-dark ml-2" :title="msg.usuario.pessoa ? msg.usuario.pessoa.st_nome : '?'">
                                                {{ msg.usuario.st_login }}
                                            </span>
                                        </a>
                                    </div>
                                    <div :class="msg.id_usuario == $store.state.user.id_usuario ? 'text-right' : ''">{{ msg.st_mensagem }}</div>
                                </li>
                            </ul>
                        </template>
                    </template>
                </div>
                <div class="modal-footer d-flex flex-column" v-if="to">
                    <div class="w-100">
                        <div class="progress mb-1" v-if="false && mensagens && mensagens.length">
                            <div class="indeterminate" v-if="$store.state.loading"></div>
                            <div class="determinate" v-else></div>
                        </div>
                        <az-input
                            type="textarea"
                            rows="2"
                            :edicao="!$store.state.loading"
                            v-model="mensagem">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <az-submit :hide_content_while_loading="true" :disabled="!mensagem" @click="enviar()">
                                        <i class="fas fa-paper-plane"></i>
                                    </az-submit>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal de Pausa de Atendimento -->
    <div class="modal fade" id="pausaLoginModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header" v-if="false">
            <h5 class="modal-title">Pausa no Uso</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <div class="h3 mb-3">
                Pausado devido a segundo acesso
              </div>

              <div class="mb-3">
                <i class="fa-solid fa-pause fa-3x"></i>
              </div>

              <button type="button" class="btn btn-primary" :disabled="contagem > 0" @click="retomar_acesso()">
                {{ contagem ? 'Retomar em ' + contagem + ' segs...' : 'Retomar' }}
              </button>
            </div>
          </div>
          <div class="modal-footer" v-if="false">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Grupo Modal -->
    <div class="modal fade" id="grupoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" style="z-index:100000001">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="edicao_grupo">
                <div class="modal-header">
                    <h5 class="modal-title">Grupo</h5>
                    <button type="button" class="close" @click="fechar_modal('grupoModal')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <az-input
                            type="text"
                            placeholder="Informe o nome do grupo..."
                            v-model="edicao_grupo.st_titulo" 
                            required
                            :validate="validate">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <div class="input-group-text" title="Quantidade de membros ativos.">{{ lista_grupo_membros.length }}</div>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <az-input
                        placeholder="Informe o usuário..."
                        icon="fas fa-user"
                        type="autocomplete" 
                        optionsMode="aql"
                        service="usuarios.index"
                        :optionsParm="{ chat: true }"
                        v-model="novo_usuario_grupo"
                        ref="info_usuario_grupo"
                        :edicao="lista_grupo_membros.length < 20"
                        @input="incluirUsuarioGrupo()" />

                    <div class="alert alert-secondary mb-1" v-if="lista_grupo_membros.length >= 20">
                        Limite de 20 membros ativos por grupo atingido.
                    </div>

                    <ul class="list-group" v-if="lista_grupo_membros.length > 0">
                        <li class="list-group-item d-flex justify-content-between" v-for="(membro, imx) in lista_grupo_membros" :key="imx">
                            <div>
                                <a href="#" class="text-danger mr-3" @click.prevent="remover_grupo_membro(membro)" v-if="membro.id_usuario != $store.state.user.id_usuario">
                                    <i class="fas fa-times"></i>
                                </a>
                                {{ membro.usuario.pessoa.st_nome }}
                                <span class="small ml-2 text-muted">{{ membro.usuario.st_login }}</span>
                            </div>
                            <div>
                                <az-input
                                    sizing="sm"
                                    type="button-group"
                                    :optionsList="[
                                        { id: true, search: 'Adm' }, 
                                        { id: false, search: 'Membro' }, 
                                    ]"
                                    optionsData="id"
                                    :edicao="membro.id_usuario != $store.state.user.id_usuario"
                                    v-model="membro.fl_adm">
                                </az-input>
                            </div>
                        </li>
                    </ul>

                    <az-empty-state 
                        v-else 
                        msg="Nenhuma usuário no grupo." 
                        icon="fa-solid fa-users-line" />

                    <br><br><br><br><br><br><br><br><br><br>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar_modal('grupoModal')">Fechar</button>
                    <az-submit @click="salvar_grupo()">{{ edicao_grupo.id_chat_sala ? 'Atualizar' : 'Incluir' }}</az-submit>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import { setInterval } from "timers";
 
export default {
    data() {
        return {
            users: [],
            open: false, 
            mensagem: "",
            mensagens: [], 
            to: null,
            search: "",  
            viewMode: "ON",
            usuarioSelecionado: "", 
            recentes: null,
            aviso_sonoro: false,
            id_usuario: null,
            pode_retomar: false,
            tmaInterval: null,
            contagem: null, 
            retomado: false, 
            lista_conectados: null, 
            edicao_grupo: null, 
            validate: false,
            novo_usuario_grupo: "",
            grupos: null, 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzEmptyState,
    },

    computed: { 
        lista_grupo_membros: function () {
            if ( !this.edicao_grupo || !this.edicao_grupo.membros )
                return [];

            return this.edicao_grupo.membros.filter(item => item.fl_ativo);
        },

        opcoes_selecao: function () { 
            let opcoes = [
                { id: 'ON', search: 'Conectados' },
                { id: 'OFF', search: 'Todos' },
                { id: 'REC', search: 'Recentes' },
            ];

            if ( this.grupos && this.grupos.length ) { 
                opcoes.push({ id: 'GRP', search: 'Grupos' });
            }

            if ( this.$store.state.user.msg_nao_lidas && this.$store.state.user.msg_nao_lidas.length ) { 
                opcoes.push({ id: 'MNL', search: 'Não Lidas' });
            }

            return opcoes;
        },

        conectados: function () { 
            return this.users.filter(item => item.id_usuario != 1).length;
        },

        lista: function () { 
            if ( !this.users || !this.users.length )
                return [];

            let reg = this.$util.getregex(this.search);

            let base = this.viewMode == 'ON' ? ( this.lista_conectados ? this.lista_conectados : [] ) : this.users;
            
            if ( window.redir == 'labs' && this.$store.state.user.id_unidade_operacao ) { 
                base = base.filter(item => item.uo == this.$store.state.user.id_unidade_operacao);
            }
            
            return _.orderBy(
                    base.filter(item => item.id_usuario != 1)
                        .filter (item => ( !this.search || reg.test(JSON.stringify(item)))),
                    (item) => item.search ? item.search : item.name    
                );
        },

        nao_lidas: function() { 
            return _.groupBy(this.$store.state.user.msg_nao_lidas, 
                item => { 
                    if ( item.sala && item.sala.st_tipo == 'P2G' ) { 
                        return 'Grupo: ' + item.sala.st_titulo;
                    }

                    return item.usuario.search
                });
        }
    },
    methods: {
        remover_grupo_membro (membro) { 
            if ( membro && ( membro.id_usuario == this.$store.state.user.id_usuario ) ) { 
                if ( !confirm('Tem certeza que deseja se sair do grupo?') ) { 
                    return; 
                }
            } else { 
                if ( !confirm("Confirma remover '" + membro.usuario.pessoa.st_nome + "' do grupo?'") ) { 
                    return; 
                }
            }

            membro.fl_ativo = false; 
        },

        fechar_modal(modal) { 
            $('#'+modal).modal('hide');
        },

        // Grupo...

        remover_membro () { 
            alert('Oi');
            // this.edicao_grupo.membros = this.edicao_grupo.membros.filter(item => item.id_usuario != membro.id_usuario);
        },

        salvar_grupo () { 
            this.$util.atualizar(this, { 
                service: 'chat',
                func: 'salvar_grupo',
                dados: this.edicao_grupo,
                modal: 'grupoModal',
                toast: true, 
            });
        }, 

        incluirUsuarioGrupo () { 

            if ( !this.novo_usuario_grupo )
                return;

            if ( this.edicao_grupo.membros.find(item => item.id_usuario == this.novo_usuario_grupo.id_usuario) ) { 
                this.$toast.add({ 
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Usuário já está no grupo.'
                });
            } else { 
                this.edicao_grupo.membros.push({ 
                    id_usuario: this.novo_usuario_grupo.id_usuario, 
                    usuario: this.novo_usuario_grupo,
                    fl_ativo: true 
                });
            }

            this.novo_usuario_grupo = null;

            this.$nextTick(() => {
                this.novo_usuario_grupo = "";
            });

        },

        editar_grupo (grupo) { 
            this.validate = false; 
            
            this.edicao_grupo = _.cloneDeep(grupo);

            $('.modal').modal('hide');
            $('#grupoModal').modal('show');
        },
        
        incluir_grupo() { 
            this.validate = false; 
            this.edicao_grupo = { 
                id_chat_sala: null, 
                st_titulo: "", 
                st_tipo: 'P2G', 
                membros: [], 
            };

            this.edicao_grupo.membros.push({ 
                id_usuario: this.$store.state.user.id_usuario, 
                usuario: this.$store.state.user,
                fl_ativo: true,
                fl_adm: true, 
            });

            $('.modal').modal('hide');
            $('#grupoModal').modal('show');
        },

        //

        terminar_contador() { 
            clearInterval(this.tmaInterval);
            this.tmaInterval = null;
        },

        retomar_acesso () { 

            this.retomado = false;

            this.$util.atualizar(this, { 
                service: 'usuarios',
                func: 'retomar_acesso',
                dados: { 
                    origem: this.$util.getCookie('origem-uuid'),
                }, 
                callback: () => { 
                    this.retomado = true;
                    $('#pausaLoginModal').modal('hide');
                }
            });

        },

        desconectar (user) { 

            if ( !user || user.desconexao )
                return;

            user.desconexao = true;
            this.$forceUpdate();

            this.$util.atualizar(this, { 
                service: 'usuarios',
                func: 'desconectar',
                dados: { 
                    id_usuario: user.id_usuario,
                },
                toast: true, 
            });

        },

        toggle_aviso_sonoro () { 
            this.aviso_sonoro = !this.aviso_sonoro;

            this.$util.setCookie('chat-som', this.aviso_sonoro ? 'S' : 'N');
        },

        beep() {
            if ( this.aviso_sonoro ) { 
                const el = document.getElementById("beepChatId");
                el.play();
            }
        },

        trocar_opcao () { 
            if ( this.viewMode == 'REC' ) { 
                this.carregar_recentes();
            }
        },

        selecionar_classe(classe) { 
            if ( this.search == '"' + classe + '"' ) { 
                this.search = '';
             } else { 
                this.search = '"' + classe + '"';
             }
        },

        is_online(to) { 
            return this.users.find(item => item.id_usuario == to.id_usuario) ? true : false;
        },

        selecionarUsuario() { 
            if ( !this.usuarioSelecionado )
                return;

            this.abrirSala(this.usuarioSelecionado);
            this.usuarioSelecionado = "";
        },

        log() { 
            console.log('users', this.users);
        },
        abrir(tipo = null) { 
            //console.log('chat online', this.users);
            //EventBus.$emit('chat-mensagem', this.users);

            this.lista_conectados = null; 
            this.grupos = null; 

            this.to = null;
            this.mensagem = "";
            this.viewMode = tipo ? tipo : "ON";
            this.usuarioSelecionado = "";
            this.recentes = null;

            $('#modalChat').modal('show');

            this.$util.load(this, { 
                service: 'usuarios',
                func: 'listar_conectados',
                parms: { 
                    grupo: true, 
                },
                loadTo: res => { 
                    this.lista_conectados = res.lista;
                    this.grupos = res.grupos;
                }
            });

            
        },

        abrirSala(destino) { 
            this.to = destino;
            this.mensagem = "";
            this.mensagens = [];

            if ( destino.id_chat_sala ) { 
                this.carregar_sala_mensagens(destino.id_chat_sala);
            } else { 
                this.carregar_mensagens(destino.id_usuario);
            }
        },

        enviar () { 
            if ( this.to.id_chat_sala ) { 

                this.$util.atualizar (this, { 
                    service: 'chat',
                    func: 'send', 
                    dados: { 
                        id_chat_sala: this.to.id_chat_sala,
                        to: -1,
                        text: this.mensagem,
                    },
                    modal: 'chatPanelModal',
                    msg: "Mensagem enviada.",
                    toast: true,
                    callback: () => { 
                        this.mensagem = "";
                        this.carregar_sala_mensagens(this.to.id_chat_sala);
                    }
                });

            } else { 

                this.$util.atualizar (this, { 
                    service: 'chat',
                    func: 'send', 
                    dados: { 
                        to: this.to.id_usuario,
                        text: this.mensagem,
                    },
                    modal: 'chatPanelModal',
                    msg: "Mensagem enviada.",
                    toast: true,
                    callback: () => { 
                        this.mensagem = "";
                        this.carregar_mensagens(this.to.id_usuario);
                    }
                });

            }
        },

        carregar_sala_mensagens (id_chat_sala) { 

            this.$util.load(this, { 
                service: 'chat',
                func: 'sala_index',
                parms: { 
                    to: id_chat_sala, 
                },
                loadTo: res => { 
                    this.mensagens = res.msgs;

                    this.to = { 
                        id_chat_sala: res.sala.id_chat_sala,
                        name: res.sala.st_titulo, 
                        st_titulo: res.sala.st_titulo, 
                    };

                    console.log(this.to);

                    this.$store.state.user.msg_nao_lidas = this.$store.state.user.msg_nao_lidas.filter(msg =>  
                        !this.mensagens.find(loadedmsg => loadedmsg.id_chat_sala_mensagem == msg.id_chat_sala_mensagem)
                    );

                    this.$forceUpdate();

                    this.$nextTick(() => { 
                        $('#modalChat .modal-body').animate({ scrollTop: 9999 }, 'slow');
                    });
                }
            });

        },

        carregar_mensagens (id_usuario) { 

            this.$util.load(this, { 
                service: 'chat',
                func: 'index',
                parms: { 
                    to: id_usuario, 
                },
                loadTo: res => { 
                    this.mensagens = res.msgs;
                    this.to = { 
                        id_usuario: res.usuario.id_usuario,
                        name: res.usuario.pessoa.st_nome, 
                    };

                    this.$store.state.user.msg_nao_lidas = this.$store.state.user.msg_nao_lidas.filter(msg =>  
                        !this.mensagens.find(loadedmsg => loadedmsg.id_chat_sala_mensagem == msg.id_chat_sala_mensagem)
                    );

                    this.$nextTick(() => { 
                        $('#modalChat .modal-body').animate({ scrollTop: 9999 }, 'slow');
                    });
                }
            });

        },

        carregar_recentes() { 
            if ( !this.recentes ) { 
                this.$util.load(this, { 
                    service: 'chat',
                    func: 'recentes',
                    loadTo: res => { 
                        this.recentes = res;
                    }
                });
            }
        },

        receberMensagem(mensagem) { 

            let apenas_notificar = false;

            if ( this.to && this.to.id_usuario && mensagem.id_usuario && this.to.id_usuario != mensagem.id_usuario ) { 
                apenas_notificar = true;
            }

            if ( apenas_notificar || !$('#modalChat').hasClass('show') ) { 

                this.beep();

                const texto = "De: " + mensagem.from_name + " >> " + mensagem.text;

                this.$store.state.user.msg_nao_lidas.push(mensagem);

                this.$toasted.show(
                    texto, 
                    { 
                        theme: "outline", 
                        position: "top-center", 
                        duration : 60000,
                        className: "toastnafrente",
                        containerClass: "toastnafrente",
                        action : [
                            {
                                text : 'Fechar',
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                }
                            },
                            {
                                text : 'Chat',
                                onClick : () => {
                                    this.$toasted.clear();
                                    this.abrir();
                                    this.abrirSala({ id_usuario: mensagem.from, id_chat_sala: mensagem.id_chat_sala });
                                }

                            }
                        ]
                    }
                );

            } else { 

                this.$util.load(this, { 
                    service: 'chat',
                    func: 'index',
                    parms: { 
                        to: mensagem.from, 
                    },
                    loadTo: res => { 
                        this.mensagens = res.msgs;
                        this.to = { 
                            id_usuario: res.usuario.id_usuario,
                            name: res.usuario.pessoa.st_nome, 
                        };

                        this.$nextTick(() => { 
                            $('#modalChat .modal-body').animate({ scrollTop: 9999 }, 'slow');
                        });
                    }
                });

            }

        },

        teste() { 
            //$('#chatUsersModal').modal('show');
            this.open = !this.open;
        },
        sendMessage (text) {
        if (text.length > 0) {
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            this.onMessageWasSent({ author: 'support', type: 'text', data: { text } })
        }
        },
        onMessageWasSent (message) {
            // called when the user sends a message
            this.messageList = [ ...this.messageList, message ]
        },
        openChat () {
            // called when the user clicks on the fab button to open the chat
            this.isChatOpen = true
            this.newMessagesCount = 0
        },
        closeChat () {
            // called when the user clicks on the botton to close the chat
            this.isChatOpen = false
        },
        handleScrollToTop () {
            // called when the user scrolls message list to top
            // leverage pagination for loading another page of messages
        },
        handleOnType () {
            console.log('Emit typing event')
        },
        editMessage(message){
            const m = this.messageList.find(m=>m.id === message.id);
            m.isEdited = true;
            m.data.text = message.data.text;
        }
    },

    beforeDestroy() { 
        let dominio = this.$store.state.dominio;
        
        window.Echo.private(dominio + '.' + this.id_usuario).stopListening(".chat");
        window.Echo.private(dominio + '.' + this.id_usuario).stopListening(".aviso");
        
        window.Echo.leave('online.' + dominio);

        if ( this.$store.state.user ) { 
            let id_usuario = this.$store.state.user.id_usuario;
            window.Echo.leave(dominio + '.' + id_usuario);
        }
    },

    mounted() { 
        this.aviso_sonoro = ( this.$util.getCookie('chat-som') == 'S' );

        $('#pausaLoginModal').on('hidden.bs.modal', () => {
            if ( !this.retomado ) { 
                this.$store.commit("setUser", null);
            }
        });

        let dominio = this.$store.state.dominio;
        let id_usuario = this.$store.state.user.id_usuario;

        this.id_usuario = id_usuario;

        window.Echo.join('online.' + dominio)
            .here(users => { 
                // console.log('Here', users);

                this.users = users.map(item => { 
                    item.desconexao = false;
                    return item;
                });

                this.$store.commit('setConectados', this.conectados);

                let klics = this.$store.state.user.klics ? this.$store.state.user.klics : 0;

                console.log('klics', klics);

                if ( this.$store.state.user.id_usuario != 1 
                    && this.$store.state.user.lics > 0 
                    && ( this.conectados + klics ) > this.$store.state.user.lics ) { 
                    
                    const info = { 
                        user: this.$store.state.user.id_usuario,
                        st_login: this.$store.state.user.st_login,
                        lics: this.$store.state.user.lics,
                        klics: klics,
                        conectados: this.conectados, 
                        lista: this.users.map(item => item.id_usuario),
                    }

                    this.$util.loadItem(this, { 
                        service: 'chat',
                        func: 'lics',
                        parms: info, 
                    })
                    .then(() => { 
                        /*
                        if ( res.block ) { 

                            console.log('Desconectando Lics...', info);

                            this.$store.commit("setUser", null);

                            this.$nextTick(() => { 
                                this.$toast.add({
                                    severity: "error",
                                    summary: "Atenção",
                                    detail: "Licenças excedidas.",
                                    life: 7000
                                });
                            });

                        } else if ( res.alert ) {  

                            console.log('Informando Lics...', info);

                            this.$nextTick(() => { 
                                this.$toast.add({
                                    severity: "warn",
                                    summary: "Atenção",
                                    detail: "Licenças excedidas => " 
                                        + " Licenças: " + info.lics 
                                        + " / Conectados: " + info.conectados
                                        + ( klics > 0 ? " / Klis: " + klics : "" ),
                                    life: 7000
                                });
                            });
                            
                        }
                        */
                    });
                }
            })
            .joining(user => { 
                user.desconexao = false;

                this.users.push(user);
                this.$store.commit('setConectados', this.conectados);
            })
            .leaving(user => { 
                this.users = _.cloneDeep(this.users.filter(u => (u.id_usuario !== user.id_usuario)));
                this.$store.commit('setConectados', this.conectados);
            });

        window.Echo.private(dominio + '.' + id_usuario)
            .listen(".chat", (e) => {
                if ( e && e.data && e.data.acesso ) { 
                    
                    if ( e.data.id == id_usuario && e.data.origem && this.$util.getCookie('origem-uuid') && e.data.origem !== this.$util.getCookie('origem-uuid') ) { 

                        /*
                        console.log('e', e);
                        console.log('Origem', e.data.origem);
                        console.log('Local', this.$util.getCookie('origem-uuid'));
                        */

                        $('.modal').modal('hide');

                        let texto;

                        if ( e.data.responsavel ) { 
                            texto = 'Desconexão [' + e.data.login + '] realizada por: ' + e.data.responsavel;    
                        } else { 
                            texto = 'Acesso realizado em outro dispositivo com o mesmo login: ' + e.data.login;

                            if ( this.tmaInterval ) { 
                                clearInterval(this.tmaInterval);
                            }

                            this.contagem = 10;
                            let timer = setInterval(() => {
                                if ( this.contagem > 0 ) { 
                                    this.contagem --;
                                } 
                              
                                console.log('C', this.contagem);

                                if ( this.contagem <= 0 ) { 
                                    
                                    if ( timer._id ) { 
                                        clearInterval(timer._id);
                                    } else if ( timer.id ) { 
                                        clearInterval(timer.id);
                                    } else {  
                                        clearInterval(timer);
                                    }
                                    
                                }
                            }, 1000);

                            this.retomado = false;

                            $('#pausaLoginModal').modal('show');
                            return;
                        }

                        this.$toasted.show(
                            texto, 
                            { 
                                theme: "toasted-primary", 
                                position: "bottom-center", 
                                className: "toastnafrente",
                                containerClass: "toastnafrente",
                                action : [
                                    {
                                        text : 'Fechar',
                                        onClick : (e, toastObject) => {
                                            toastObject.goAway(0);
                                        }
                                    },
                                ]
                            }
                        );

                        this.$store.commit("setUser", null);

                    }

                    return;
                }

                if ( !this.$store.state.user ) { 
                    return;
                } else if ( this.$store.state.user.id_usuario != id_usuario ) { 
                    return;
                }

                this.receberMensagem(e.data);
            })
            .listen(".aviso", (e) => {
                if ( !this.$store.state.user ) { 
                    return;
                } else if ( this.$store.state.user.id_usuario != id_usuario ) { 
                    return;
                }

                this.$util.exibir_aviso(e.data);
            });
    }

}

</script>

<style>
.bottomright {
  position: absolute;
  bottom: 8px;
  right: 16px;
}

.toastnafrente { 
    z-index: 100000001 !important;
}
</style>